import React from 'react';
import {buildPasswordRules} from '../model/buildPasswordRules';

interface Props {
  password: string;
  context: any;
  settings: any;
}

const PasswordRulesHint = ({password, context, settings}: Props) => {
  // If no password or no settings, nothing to show
  if (!password || !settings) return null;

  // When editing, backend may provide an encrypted password. Do not show
  // the rules hint if the current password equals the original encrypted
  // value coming from the server (i.e. user didn't change it).
  if (context && context.passwordOriginal && password === context.passwordOriginal) return null;

  const rules = buildPasswordRules(settings);

  const evaluatedRules = rules.map((rule) => ({
    ...rule,
    valid: rule.test(password, context),
  }));

  const hasInvalid = evaluatedRules.some((r) => !r.valid);
  if (!hasInvalid) return null;

  return (
    <ul style={{marginTop: 8, paddingLeft: 18}}>
      {evaluatedRules.map((rule) => (
        <li
          key={rule.key}
          style={{
            color: rule.valid ? '#2e7d32' : '#9e9e9e',
            fontSize: 13,
          }}>
          {rule.valid ? '✔' : '•'} {rule.label}
        </li>
      ))}
    </ul>
  );
};

export default PasswordRulesHint;
